export const radii = {
  regular: 0,
  round: 4,
  rounder: 8,
  roundest: 24,
  pill: 9999,
  circle: "50%"
};
